import { atom } from 'recoil';
import { Option } from 'Types/common.types';

export type GlobalFilterAtomType = {
  __isInitializing__?: boolean;
  logisticsProviderIds?: Array<string>;
  companyIds?: string[];
  selectedOrgIDs?: string[];
}

export const GlobalFilterAtom = atom<GlobalFilterAtomType>({
  key: 'globalFilterAtom',
  default: {
    __isInitializing__: true, //* this field is to tell the consumer of this atom, that the default data of this atom is not valid as user input
    logisticsProviderIds:[],
    companyIds: [],
    selectedOrgIDs: [],
  },
});



